import i18n from "@/language/i18n";

export const handleTranslationForNextModule = (to) => {
    if (isThereATranslationFileForNextModule(to) === true) {
        mergeTranslationFileOfModuleIntoComponents(to);
    }
}

const isThereATranslationFileForNextModule = (to) => {
    return to?.meta?.[getCurrentLocale()] != undefined;
}

const mergeTranslationFileOfModuleIntoComponents = (to) => {
    i18n.mergeLocaleMessage(getCurrentLocale(), to.meta[getCurrentLocale()]);
}

const getCurrentLocale = () => i18n.locale;
